import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { LoopPlannerScenarioApi } from '@/lib/api/loop-planner/scenario';
import { loopPlannerQueryKeys } from '@/lib/query-keys/loop-planner';

export const getScenariosQueryOptions = ({ loopId }: { loopId: number }) =>
  queryOptions({
    queryKey: loopPlannerQueryKeys.scenarios.list({ loopId }),
    queryFn: () => LoopPlannerScenarioApi.getScenarios({ loopId }),
    staleTime: 0,
    refetchOnWindowFocus: true,
  });

export const useGetScenariosSuspense = ({ loopId }: { loopId: number }) => {
  return useSuspenseQuery(getScenariosQueryOptions({ loopId }));
};

export const useGetScenarios = ({ loopId }: { loopId: number }) => {
  return useQuery(getScenariosQueryOptions({ loopId }));
};
